import React, { useState } from 'react';
import HomeUI from '../contents/HomeUI';
import BuyModal from '../modals/BuyModal';
import { useSystemTheme } from '../utils/useSystemTheme';

const Home = ({ onPlay, fadeOut, showAnimation, setCenterText }) => {
    const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);
    const [selectedBook, setSelectedBook] = useState(null);

    const theme = useSystemTheme();

    const handleBookAccess = (id) => {
        setSelectedBook(id);
        setPaymentModalOpen(true);
    };

    const gradientClass =
        theme === "dark"
            ? "bg-gradient-to-tr from-[#1f2937] via-[#111827] to-[#0f172a]"
            : "bg-gradient-to-tr from-[#FFF8F3] via-[#FFF8F3] to-[#FFF8F3]";

    return (
        <div className={`relative ${gradientClass} h-screen`}>
            <HomeUI
                onPlay={onPlay}
                onBookAccessDenied={handleBookAccess}
                fadeOut={fadeOut}
                showAnimation={showAnimation}
                setCenterText={setCenterText}
            />
            {isPaymentModalOpen && (
                <BuyModal
                    isOpen={isPaymentModalOpen}
                    bookId={selectedBook}
                    onClose={() => setPaymentModalOpen(false)}
                />
            )}
        </div>
    );
};

export default Home;